<template>
  <div class="app-container pb-6">
    <span class="title">{{ video.title }}</span>

    <div class="video" v-if="video.link">
      <iframe
        :src="video.link"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
        class="iframe-shadowed"
      ></iframe>
    </div>

    <!-- <div class="mt-4 text-right" v-if="video.details_link">
      <v-btn color="secondary" :href="video.details_link.href" target="_blank">
        {{ video.details_link.text }}
      </v-btn>
    </div> -->

    <div v-if="video.downloads" class="my-4 text-center">
      <div
        v-for="vFile in video.downloads"
        :key="video.link + '-' + vFile.name"
        :href="'/' + vFile.file"
        download
        class="grey lighten-2 px-4 mt-1"
      >
        <v-row class="flex-nowrap align-center">
          <v-col class="subtitle-1 text-left">
            <strong>{{ getName(vFile.file) }}</strong>
          </v-col>
          <v-col class="text-right flex-shrink-1 flex-grow-0">
            <v-btn color="secondary"  @click="download_file(vFile.id)">Download</v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JumpStartVideo',
  props: ['video'],
  methods: {
    getName(filePath) {
      const path = filePath.split('/');
      return path[path.length - 1];
    },
    getLink(filename) {
      return `${process.env.VUE_APP_API_BASE_URL}${filename}`;
    },
    download_file(file){
      let file_path = process.env.VUE_APP_API_BASE_URL +"download?id=" + file;
      let docUrl = document.createElement('a');
      docUrl.href = file_path;
      docUrl.setAttribute('target', '_blank');
      document.body.appendChild(docUrl);
      docUrl.click();
    }
  }
}
</script>

<style lang="scss">
.app-container {
  width: 70%;
  margin: 0 auto;
}

.video {
  padding: 56.25% 0 0 0;
  position: relative;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>